<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'feepromotion'+order.id">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false"
      :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="close()">
      <div :class="{mobile_upload_order:mobiletype}">
        <h3 class="text-center"><i v-if="step > 1" class="el-icon-arrow-left back" @click="step--"></i>减免服务费</h3>
        <div v-if="step == 1">
          <div style="min-height:297px;position: relative;">
            <div v-if="isfetching" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
              <Loading></Loading>
            </div>
            <ul v-if="predata" class="popover-price">
              <li><span>商品</span><del
                  v-if="predata.goods_price.need_frontend_calculate!=1 && predata.original_goods_price.value != predata.goods_price.value">{{predata.original_goods_price.currency_symbol}}{{predata.original_goods_price.value}}</del>
                <label v-if="predata.goods_price.need_frontend_input!=1">{{predata.goods_price.currency_symbol}}{{predata.goods_price.value}}</label>
                <el-input v-if="predata.goods_price.need_frontend_input==1" placeholder="价格" v-model="predata.goods_price.value">
                  <template slot="append">{{predata.goods_price.currency}}</template>
                </el-input>
              </li>
              <li><span>消费税</span><del
                  v-if="predata.tax_price.need_frontend_calculate!=1 && predata.original_tax_price.value != predata.tax_price.value">{{predata.original_tax_price.currency_symbol}}{{predata.original_tax_price.value}}</del>
                  <label v-if="predata.tax_price.need_frontend_input!=1">{{predata.tax_price.currency_symbol}}{{predata.tax_price.value}}</label>
                  <el-input v-if="predata.tax_price.need_frontend_input==1" placeholder="价格" v-model="predata.tax_price.value">
                    <template slot="append">{{predata.tax_price.currency_symbol}}</template>
                  </el-input>
              </li>
              <li><span>商家运费</span><del
                  v-if="predata.transport_price.need_frontend_calculate!=1 && predata.original_transport_price.value != predata.transport_price.value">{{predata.original_transport_price.currency_symbol}}{{predata.original_transport_price.value}}</del>
                  <label v-if="predata.transport_price.need_frontend_input!=1">{{predata.transport_price.currency_symbol}}{{predata.transport_price.value}}</label>
                  <el-input @change="recomputetotal('transport_price')" v-if="predata.transport_price.need_frontend_input==1" placeholder="价格" v-model="predata.transport_price.value">
                    <template slot="append">{{predata.transport_price.currency}}</template>
                  </el-input>
              </li>
              <li><span>其他费用</span><del
                  v-if="predata.other_price.need_frontend_calculate!=1 && predata.original_other_price.value != predata.other_price.value">{{predata.original_other_price.currency_symbol}}{{predata.original_other_price.value}}</del>
                  <label v-if="predata.other_price.need_frontend_input!=1">{{predata.other_price.currency_symbol}}{{predata.other_price.value}}</label>
                  <el-input @change="recomputetotal('other_price')" v-if="predata.other_price.need_frontend_input==1" placeholder="价格" v-model="predata.other_price.value">
                    <template slot="append">{{predata.other_price.currency}}</template>
                  </el-input>
              </li>
              <li><span>商家小计</span><del
                  v-if="predata.subtotal_price.need_frontend_calculate!=1 && predata.original_subtotal_price.value != predata.subtotal_price.value">{{predata.original_subtotal_price.currency_symbol}}{{predata.original_subtotal_price.value}}</del>
                  <label v-if="predata.subtotal_price.need_frontend_input!=1">{{predata.subtotal_price.currency_symbol}}{{predata.subtotal_price.value}}</label>
                  <el-input v-if="predata.subtotal_price.need_frontend_input==1" placeholder="价格" v-model="predata.subtotal_price.value">
                    <template slot="append">{{predata.subtotal_price.currency}}</template>
                  </el-input>
              </li>
              <li v-if="predata.discount_price.value!='0.00' || predata.original_discount_price.value!='0.00'">
                <span>下单优惠</span>
                <del v-if="predata.original_discount_price.value != predata.discount_price.value">-{{predata.original_discount_price.currency_symbol}}{{predata.original_discount_price.value}}</del> {{predata.discount_price.currency_symbol}}{{predata.discount_price.value}}
              </li>
              <li v-if="discount_rule.discount_price || order.joyorders_promo_code">
                <div class="promo_code" v-if="order.joyorders_promo_code">{{order.joyorders_promo_code}}</div>
                <div>{{discount_rule.discount_price}}</div>
              </li>
              <hr class="line">
              <li><span>服务费</span><del
                  v-if="predata.service_price.need_frontend_calculate!=1 && predata.original_service_price.value != predata.service_price.value">{{predata.original_service_price.currency_symbol}}{{predata.original_service_price.value}}</del>
                  <label v-if="predata.service_price.need_frontend_input!=1">{{predata.service_price.currency_symbol}}{{predata.service_price.value}}</label>
                  <el-input @change="recomputetotal('service_price')" v-if="predata.service_price.need_frontend_input==1" placeholder="价格" v-model="predata.service_price.value">
                    <template slot="append">{{predata.service_price.currency}}</template>
                  </el-input>
              </li>
              <li v-if="discount_rule.buyer_service_fee">
                <div class="promo_code" v-if="order.joyorders_promo_code">{{order.joyorders_promo_code}}</div>
                <div>{{discount_rule.buyer_service_fee}}</div>
              </li>
              <hr class="line">
              <li v-if="order.service_type==2"><span>国际运费</span><del
                  v-if="predata.international_transport_price.value != predata.original_international_transport_price.value">{{predata.original_international_transport_price.currency_symbol}}{{predata.original_international_transport_price.value}}</del>
                  <label v-if="predata.international_transport_price.need_frontend_input!=1">{{international_transport_price_display()}}</label>
                  <el-input @change="recomputetotal('international_transport_price')" v-if="predata.international_transport_price.need_frontend_input==1" placeholder="价格" v-model="predata.international_transport_price.value">
                    <template slot="append">{{predata.international_transport_price.currency}}</template>
                  </el-input>
              </li>
              <li><span>实时汇率</span>{{predata.rate}}</li>
              <li><span>总计</span><del
                  v-if="predata.total_price.need_frontend_calculate!=1 && predata.original_total_price.value != predata.total_price.value">{{predata.original_total_price.currency_symbol}}{{predata.original_total_price.value}}</del>
                  <label v-if="predata.total_price.need_frontend_input!=1">{{predata.total_price.currency_symbol}}{{predata.total_price.value}}</label>
                  <el-input v-if="predata.total_price.need_frontend_input==1" placeholder="价格" v-model="predata.total_price.value">
                    <template slot="append">{{predata.total_price.currency}}</template>
                  </el-input>
              </li>
              <li><span>{{predata.payment_status}}</span>
                {{predata.payment_price.currency_symbol}}{{predata.payment_price.value}}
              </li>
              <li v-if="predata.paying_amount && predata.paying_amount.value!='0.00'"><span>支付中</span>
                {{predata.paying_amount.currency_symbol}}{{predata.paying_amount.value}}
              </li>
              <li v-if="predata.paying_amount && predata.paying_amount.value!='0.00'"><span>退款中</span>
                {{predata.refunding_amount.currency_symbol}}{{predata.refunding_amount.value}}
              </li>
              <!--<li><span>{{predata.price_adjustment_status}}</span>
                {{predata.price_adjustment_rmb.currency_symbol}}{{predata.price_adjustment_rmb.value}}
              </li>-->
            </ul>
          </div>
          <div class="fee_row">
            <el-button class="block" :type="'primary'" @click="submit" :loading="loading" :disabled="!predata">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import api from '../../../../services/api.js'
  import { API_HOST } from '../../../../services/constant.js'
  import ProductList from './ProductList'
  import Loading from '../../../../components/Loading'
  let _ = require('lodash')

  export default {
    name: 'CancelProduct',
    props: ['order', 'isSingle','mobiletype'],
    components: {
      ProductList: ProductList,
      Loading:Loading
    },
    computed: {
    },
    data() {
      return {
        discount_rule:{},
        canGoStep2:true,     
        dialogFormVisible: false,
        isfetching:false,
        loading: false,
        step: 1,
        isEmptyErrors: true,
        errors: {},
        ids: [],
        status: '', // 订单状态
        data: [],
        fee_info: [
          { name: '商品金额', editMode: false, fee: 0, fieldName: 'goods_price', canEdit: false },
          { name: '消费税', editMode: false, fee: 0, fieldName: 'tax_price', canEdit: false },
          { name: '商家运费', editMode: false, fee: 0, fieldName: 'transport_price', canEdit: true },
          { name: '其他费用', editMode: false, fee: 0, fieldName: 'other_price', canEdit: true },
          { name: '汇率', editMode: false, fee: 0, fieldName: 'rate', canEdit: false },
          { name: '商家小计', editMode: false, fee: 0, fieldName: 'subtotal_price', canEdit: false },
          { name: '服务费', editMode: false, fee: 0, fieldName: 'service_amount', canEdit: false },
          { name: '国际运费', editMode: false, fee: 0, fieldName: 'international_transport_price', canEdit: true },
          { name: '待退回', editMode: false, fee: 0, fieldName: 'total_price', canEdit: false },
        ],
        flexFeeRate: 0,
        fixedFee: 0,
        restGoods: [],
        cancelGoods:[],
        zhiyoumobanlist:[],
        //restfreightRes:'',
        //restexpressPrice:'',
        isStartCaculating:false,
        predata:null,
        original_predata:null
        //international_transport_price_no:'按重量实收'
      }
    },
    methods: {
      international_transport_price_display(){
        let t=this.predata.international_transport_price.currency_symbol+this.predata.international_transport_price.value
        switch(this.predata.international_transport_price.charge_type){
          case "1":
          case "2":
            return this.predata.international_transport_price.charge_type_message+t;
          default:
            return t
        }
      },
      show() {
        this.getpredata()
        this.dialogFormVisible = true
      },
      close() {
        this.isEmptyErrors = true
        this.errors = {}
        this.step = 1
      },
      async submit() {
        this.loading=true;
        let res
        res = await api.post(this, {
              path: 'order.php',
              api: 'free_service_price',
              data: {
                order_id: this.order.id,            
              },
              loading: 'loading'
          })
          this.loading=false;
          res = res.body
          if (res.status == 'ok') {
            Object.assign(this.order, res.result)
      
            this.dialogFormVisible = false
            this.step = 1
            //this.$emit('complete', this.data)
            this.$emit('refresh',res.result.price_info)
          }
      },
      
      gotStep2(){
        this.isEmptyErrors = true
        this.errors = {}
        if (this.order.type == '2') {
          let totalPrice=0;
          _.each(this.goods_info, item => {
            /*if (!item.image && !item.remark) {
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  {message: '请上传要取消的商品截图/凭证或填写要取消的商品名称和信息'}
                ]
              }
              return false*/
            if (!item.remark) {
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  { message: '请填写要取消的商品名称和信息' }
                ]
              }
              return false
            } else if (!item.inputPrice || isNaN(Number(item.inputPrice))) {
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  { message: '请填写正确的价格' }
                ]
              }
              return false
            } else if(!item.image){
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  { message: '图文模式取消商品必须上传图片' }
                ]
              }
              return false
            }else {
              totalPrice+=(+item.inputPrice)
              this.isEmptyErrors = true
              this.errors = {}
            }
          })
          if(totalPrice>(+this.order.price_info.goods_price.value)){
            this.isEmptyErrors = false
                  this.errors = {
                    business_name: [
                      { message: '价格超出了任务总价格' }
                    ]
                  }
            return false
          }
          if(totalPrice==(+this.order.price_info.goods_price.value)){
            this.needCancelAll=true;
          }
        }
        else{
          if(!this.canGoStep2){
            this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  { message: '请至少勾选一件商品' }
                ]
              }
            return 
          }
        }
        // 这个是报错信息的返回
        if (!this.isEmptyErrors) {
          return
        }
        this.step=2;
      },
      getpredata() {
        this.predata=null
        this.isfetching=true
        this.discount_rule={}
        let url=API_HOST+"/api/order.php?api=get_price_info&type=7";
        this.$http.post(url,{order_id:this.order.id}).then(data =>{ 
            this.isfetching=false;
            
            this.predata=data.body.result;
            this.isStartCaculating=false;
            for(let p in this.predata.discount_rule_info){
              if(!this.predata.discount_rule_info[p].error){
                if(this.predata.discount_rule_info[p].discount_rule)
                  this.discount_rule[p]=this.predata.discount_rule_info[p].discount_rule.display_name
              }
            }  
        })
      },
      isJsonString(str) {
        try {
          if (typeof JSON.parse(str) == 'object')
            return true
        }
        catch (e) {
          return false;
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .popover-price {
    padding: 13px 13px;
    li {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }

      del {
        color: #B0B4BF;
      }
    }

    .line {
      float: left;
      width: 100%;
      height: 1px;
      border: 1px dashed #ccc;
    }
  }
  .cancel-body {
    display: flex;
  }

  .dialog-form {
    padding-bottom: 40px;
  }

  .tip {
    font-size: 16px;
    color: rgba(136, 136, 136, 1);
    line-height: 24px;
    margin-bottom: 5px;
  }

  .add-tip {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 24px;
    margin-left: 5px;
  }

  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
    margin-bottom: 10px;
  }

  .mobile_upload_order {
    padding: 10px;
  }

  .error-messages {
    display: block;
    background-color: #fff1f1;
    padding: 10px;
    text-align: center;
    color: #ff4650;
    line-height: 17px;
    margin-bottom: 10px;
    border-radius: 5px;

    li {
      font-size: 12px;
    }
  }

  .fee_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0;
  }

  .fee_row label.canEdit {
    cursor: pointer;
  }
  .promo_code{
    border: 1px solid #D9D9D9;
    display: inline-block;
    padding: 0 10px;
    font-size: 13px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/orders/list/single/FeePromotionDialog.vue